module.exports = __webpack_public_path__ + "img/pdf.e7e236bd.svg";